export default __webpack_public_path__ + "static/media/folder_search.4fb62e7d.svg";